// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2E7no","content":"styles_content__253UI","selectAll":"styles_selectAll__19QQz"};